// Opens the floating "Chat with BIBA" window from anywhere on the site,
// optionally with an order preselected as the subject of the next message.
export const OPEN_CHAT_EVENT = "biba-open-chat";

export const openChat = (detail = {}) => window.dispatchEvent(new CustomEvent(OPEN_CHAT_EVENT, { detail }));
